export default {
    speed: 450,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    allowTouchMove: false,
    slidesPerView: 'auto',
    spaceBetween: 0,
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/testimonial-slider/slider-config.js